import type { TFunction } from 'i18next'
import type {
  AgeCategory,
  RenovationStatus,
} from '../ConstructionTimelineTab.types'
import {
  AGE_THRESHOLDS,
  RENOVATION_THRESHOLDS,
} from '../ConstructionTimelineTab.constants'

export const getAgeCategory = (age: number, t: TFunction): AgeCategory => {
  if (age < AGE_THRESHOLDS.NEW)
    return {
      label: t('overview.ageCategories.new.label'),
      type: 'success' as const,
    }
  if (age < AGE_THRESHOLDS.CONTEMPORARY)
    return {
      label: t('overview.ageCategories.contemporary.label'),
      type: 'info' as const,
    }
  if (age < AGE_THRESHOLDS.MATURE)
    return {
      label: t('overview.ageCategories.mature.label'),
      type: 'warning' as const,
    }
  return {
    label: t('overview.ageCategories.historic.label'),
    type: 'danger' as const,
  }
}

export const getRenovationStatus = (
  yearsSince: number,
  t: TFunction
): RenovationStatus => {
  if (yearsSince === 0)
    return {
      label: t('timeline.renovationStatuses.noRenovation'),
      type: 'info' as const,
    }
  if (yearsSince < RENOVATION_THRESHOLDS.RECENT)
    return {
      label: t('timeline.renovationStatuses.recentlyRenovated'),
      type: 'success' as const,
    }
  if (yearsSince < RENOVATION_THRESHOLDS.GOOD)
    return {
      label: t('timeline.renovationStatuses.goodCondition'),
      type: 'info' as const,
    }
  if (yearsSince < RENOVATION_THRESHOLDS.CONSIDER_UPDATES)
    return {
      label: t('timeline.renovationStatuses.considerUpdates'),
      type: 'warning' as const,
    }
  return {
    label: t('timeline.renovationStatuses.renovationNeeded'),
    type: 'danger' as const,
  }
}
